<div class="container" loading-spin [isLoading]="reloading" [loadingSize]="'big'" tabindex="-1"
    (keydown)="onKeydown($event)">
    <div class="no-data" [style.display]="showNoData()">
        <span>No Data Found</span>
    </div>
    <div #listContainer tid="note_list" class="thread-list" infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="150" [scrollWindow]="false"
        [infiniteScrollDisabled]="loadingMore || !threadEntryList.hasNext" (scrolled)="onScrolled()">
        <div class="item" *ngFor="let item of threadEntryList; index as i; trackBy:trackByFn"
            (click)="onItemSelect($event,item,i)"
            [ngClass]="selectedIndexes.has(i) ? 'active' : selectedItem && item.threadEntryThreadId === selectedItem.threadEntryThreadId ? 'passive-active' : ''"
            (contextmenu)=" onContextMenu($event,item,i)" (touchstart)="touchstart()"
            (touchend)="touchend($event,item,i)" (dblclick)="onItemDoubleClick($event, item)">
            <snippet-thread-list-item [threadEntry]="item" [sortInfo]="sortInfo"></snippet-thread-list-item>
        </div>
        <tam-context-menu [config]="contextMenuConfig" *ngIf="contextMenuConfig"></tam-context-menu>
    </div>
</div>